import { QueryClient } from '@tanstack/react-query';

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      // How long the data should remain "fresh" (in milliseconds)
      staleTime: 5 * 60 * 1000, // 5 minutes
      
      // How long to cache the data when the component is inactive
      // cacheTime: 30 * 60 * 1000, // 30 minutes
      
      // Automatically refetch when window regains focus
      refetchOnWindowFocus: false,
      
      // Retry failed requests 3 times
      retry: 3,
      
      // Delay between retries (in milliseconds)
      retryDelay: (attemptIndex) => Math.min(1000 * 2 ** attemptIndex, 30000),
      
      // Show error if request takes longer than 5 seconds
      // suspense: false,
      
      // Whether to refetch on component mount if the data is stale
      refetchOnMount: true,
      
      // Keep previous data when refetching
    },
    mutations: {
      // Retry failed mutations 2 times
      retry: 2,
      
      // Delay between retries (in milliseconds)
      retryDelay: 1000
    }
  }
});

export default queryClient;